import React, {useState, useEffect} from "react";

const DarkMore = () => {
    const storedTheme = localStorage.getItem("theme");
    const isChecked = storedTheme === 'dark' ? false : true;
    const [darkMore, setDarkMore] = useState(isChecked);

    useEffect(() => {
        document.documentElement.setAttribute("theme", storedTheme);
    }, [storedTheme]);

    const setDark = () => {
        setDarkMore(false);
        localStorage.setItem("theme", "dark");
        document.documentElement.setAttribute("theme", "dark");
        document.getElementById('js-moreTheme').innerHTML = '';
    };

    const setLight = () => {
        setDarkMore(true);
        localStorage.setItem("theme", "light");
        document.documentElement.setAttribute("theme", "light");
        document.getElementById('js-moreTheme').innerHTML = '';
    };

    const toggleTheme = (e) => {
        document.getElementById('js-moreTheme').innerHTML = '';
        if (e.target.checked) {
            setLight();
            document.getElementById('js-moreTheme').innerHTML += 'Light more';
        } else {
            setDark();
            document.getElementById('js-moreTheme').innerHTML += 'Dark more';
        }
    };

    if(!storedTheme) {
        setDark();
    }

    return(
        <div className="c-darkMore">
            <label htmlFor="checkbox">
                <input type="checkbox" id="checkbox" onChange={(e) => toggleTheme(e)} defaultChecked={darkMore} />
                <div className="c-darkMore__toggle">
                    <div className="c-darkMore__light">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M8.91581 12.9561C11.147 12.9561 12.9557 11.1474 12.9557 8.9163C12.9557 6.68516 11.147 4.87646 8.91581 4.87646C6.68467 4.87646 4.87598 6.68516 4.87598 8.9163C4.87598 11.1474 6.68467 12.9561 8.91581 12.9561Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M14.2413 14.2413L14.1443 14.1443M14.1443 3.688L14.2413 3.59104L14.1443 3.688ZM3.59104 14.2413L3.688 14.1443L3.59104 14.2413ZM8.91617 1.51767V1.45801V1.51767ZM8.91617 16.3743V16.3147V16.3743ZM1.51767 8.91617H1.45801H1.51767ZM16.3743 8.91617H16.3147H16.3743ZM3.688 3.688L3.59104 3.59104L3.688 3.688Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <div className="c-darkMore__dark">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                            <path d="M1.03934 8.17742C1.26309 11.3782 3.9791 13.9824 7.22962 14.1253C9.523 14.2247 11.574 13.1557 12.8046 11.4714C13.3142 10.7816 13.0408 10.3216 12.1893 10.477C11.7729 10.5516 11.344 10.5827 10.8965 10.564C7.85734 10.4397 5.37129 7.89774 5.35886 4.89583C5.35264 4.08786 5.52045 3.3234 5.825 2.62731C6.16061 1.85663 5.75663 1.48994 4.97974 1.81934C2.51854 2.85727 0.834242 5.33711 1.03934 8.17742Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
            </label>                    
        </div>
    );
};

export default DarkMore;